import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";
import { cleanConfig } from "./plano";

function assertValidTemplate(template) {
    console.assert(template);
    console.assert(typeof template.name === "string");
    console.assert(!template.ref || typeof template.ref === "string");
    console.assert(typeof template.systemTypeId === "number");
    console.assert(typeof template.displayerTypeId === "number");
    console.assert(typeof template.standDesignId === "number");
    console.assert(Array.isArray(template.zoneIds) && !template.zoneIds.some(val => typeof val !== "number"));
    console.assert(template.config);
}

function serializeTemplate(template) {
    assertValidTemplate(template);
    const { name, systemTypeId, displayerTypeId, standDesignId, zoneIds, config } = template;

    return {
        name,
        assemblyNumber: template.ref,
        systemType: { id: systemTypeId },
        displayerType: { id: displayerTypeId },
        standDesign: { id: standDesignId },
        zones: zoneIds.map(id => ({
            id
        })),
        config: cleanConfig(config)
    };
}

/**
 * @typedef {Object} Template
 * @property {string} name
 * @property {string} ref
 * @property {number} systemTypeId
 * @property {number} displayerTypeId
 * @property {number} standDesignId
 * @property {number[]} zoneIds
 * @property {Object} config The raw planogram JSON
 */
export default {
    create(/** @type {Template} */ template) {
        return http.post(buildUrlFromLocation("/admin/displayer/new"), serializeTemplate(template));
    },
    update(id, template) {
        console.assert(typeof id === "number");
        return http.put(buildUrlFromLocation(`/admin/displayers/${id}`), serializeTemplate(template));
    },
    get(id) {
        console.assert(typeof id === "number");
        return http.get(buildUrlFromLocation(`/displayers/${id}`));
    },
    saveAs(/** @type {Template} */ id, newTemplate) {
        return http.post(buildUrlFromLocation(`/admin/displayers_save_as/${id}`), serializeTemplate(newTemplate));
    }
};



// WEBPACK FOOTER //
// ./src/services/displayer.js